// holidays.js
const holidays = {
    UK: [
      { name: "New Year's Day", date: "January 1, 2025" },
      { name: "Good Friday", date: "April 18, 2025" },
      { name: "Easter Monday", date: "April 21, 2025" },
      { name: "Early May Bank Holiday", date: "May 5, 2025" },
      { name: "Spring Bank Holiday", date: "May 26, 2025" },
      { name: "Summer Bank Holiday", date: "August 25, 2025" },
      { name: "Christmas Day", date: "December 25, 2025" },
      { name: "Boxing Day", date: "December 26, 2025" },
    ],
    UAE: [
      { name: "New Year's Day", date: "January 1, 2025" },
      { name: "Isra and Mi'raj", date: "January 26, 2025" },
      { name: "Eid al-Fitr", date: "March 30, 2025" },
      { name: "Arafat Day", date: "June 6, 2025" },
      { name: "Eid al-Adha", date: "June 7, 2025" },
      { name: "Islamic New Year", date: "June 27, 2025" },
      { name: "Prophet Muhammad's Birthday", date: "September 5, 2025" },
      { name: "National Day", date: "December 2, 2025" },
    ],
    US: [
      { name: "New Year's Day", date: "January 1, 2025" },
      { name: "Martin Luther King Jr. Day", date: "January 20, 2025" },
      { name: "Presidents' Day", date: "February 17, 2025" },
      { name: "Memorial Day", date: "May 26, 2025" },
      { name: "Independence Day", date: "July 4, 2025" },
      { name: "Labor Day", date: "September 1, 2025" },
      { name: "Columbus Day", date: "October 13, 2025" },
      { name: "Thanksgiving", date: "November 27, 2025" },
      { name: "Christmas Day", date: "December 25, 2025" },
    ],
  };
  
  export default holidays;